import React from 'react'

import { NavLink } from 'react-router-dom'

import User from '../../../../services/User'

import './styles.css'



function SideBar() {
  return (
    <div id="sidebar-content">
      {/* <div className="logo-content">
        <span>Painel Administrativo</span>
      </div> */}
      <div className="links-content">
        <NavLink className='link-item' activeClassName='link-item-active' to='/admin/activity'>Atividade</NavLink>
        <NavLink className='link-item' activeClassName='link-item-active' to='/admin/contest'>Avaliar Concurso</NavLink>
      </div>
      <div className="logout-content">
        <button
        className='logout-item link-item'
        onClick={User.signOut}>Logout</button>
      </div>
    </div>
  )
}

export default SideBar